<template>
  <div class="app-user-edit">
    <div
      v-if="!user_data.parent_id"
      class="row"
    >
      <div class="col-12 col-md-3">
        <ul class="nav nav-pills flex-column nav-left account-setting-nav mb-1 mb-md-0">
          <li
            v-for="tab in availableTabs"
            :key="tab.id"
            class="nav-item"
          >
            <a
              href="#"
              class="nav-link text-left d-flex align-items-center"
              :class="{ active: activeTab === tab.id }"
              @click.prevent="activeTab = tab.id"
            >
              <feather-icon
                :icon="tab.icon"
                size="18"
                class="mr-50"
              />
              <span class="font-weight-bold">{{ tab.label }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="col-12 col-md-9">
        <account-setting-general
          v-if="activeTab === 'general' && options.general"
          :general-data="options.general"
        />

        <account-setting-password v-else-if="activeTab === 'password'" />

        <account-setting-mariana
          v-else-if="activeTab === 'mariana' && options.mariana"
          :mariana-data="options.mariana"
        />

        <account-setting-teams
          v-else-if="activeTab === 'teams' && user_data.role == 'pro'"
          :team-data="options.team"
        />
      </div>
    </div>

    <b-card
      v-else
      bg-variant="danger"
      text-variant="white"
    >
      <b-card-text>Only admin account is allowed to change settings.</b-card-text>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import { BCard, BCardText } from 'bootstrap-vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingMariana from './AccountSettingMariana.vue'
import AccountSettingZoom from './AccountSettingZoom.vue'
import AccountSettingTeams from './AccountSettingTeams.vue'

export default {
  components: {
    BCard,
    BCardText,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingMariana,
    AccountSettingZoom,
    AccountSettingTeams,
  },
  data() {
    return {
      activeTab: 'general',
      options: {},
    }
  },
  computed: {
    user_data() {
      return this.$store.state.app.user_data
    },
    availableTabs() {
      const tabs = [
        { id: 'general', label: 'General', icon: 'UserIcon' },
        { id: 'password', label: 'Change Password', icon: 'LockIcon' },
        { id: 'mariana', label: 'Mariana Tek', icon: 'InfoIcon' },
      ]

      if (this.user_data.role == 'pro') {
        tabs.push({ id: 'teams', label: 'Teams', icon: 'UsersIcon' })
      }

      return tabs
    },
  },
  beforeCreate() {
    var self = this;
    this.$store.commit('app/loadingState', true)
    this.$http.get('https://live.ipstudio.co/api/account-setting').then(res => {
        this.$store.commit('app/loadingState', false)
        this.options = res.data 
    })
  }
}
</script>
